import React, { useEffect } from 'react';
import CollapsibleSection from '../../../common/CollapsibleSection.jsx';
import { useSelector } from 'react-redux';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';
import styles from '../base/CommonSettings.module.scss';
import DashboardImageUploadButton from '../../../common/ImageUploader/DashboardImageUploadButton.lazy.jsx';
import { useSetConfigError } from '../../hooks/useSetConfigError.js';
import Errors from '../../../common/Errors.jsx';

const IMG_PLACEHOLDER = 'https://example.com/image.png';

function isFullUrl(href) {
  return /^(https?:)?\/\//i.test(href);
}

function ImageWidgetSettings({ widgetId }) {
    const setErrors = useSetConfigError(widgetId);
    const setAttribute = useSetWidgetAttribute(widgetId);
    const image_src = useSelector(state => state.dashboard.widgets[widgetId].settings?.image_src);
    const image_size = useSelector(state => state.dashboard.widgets[widgetId].settings?.image_size);
    const attachment = useSelector(state => state.dashboard.widgets[widgetId].settings?.attachment);
    const link = useSelector(state => state.dashboard.widgets[widgetId].settings?.link);
    const errors = useSelector(state => state.dashboard.configErrors[widgetId]) || {};

    useEffect(() => {
        if (link && link.length !== 0 && !isFullUrl(link)){
            setErrors('', {link: [{message: I18n.t('image_widget_invalid_link_desc')}]})
        } else if (Object.keys(errors).length !== 0) {
            setErrors('', null)
        }
    }, [link])

    return (
        <>
        <hr />
        <CollapsibleSection title={I18n.t('content_settings')}>
            <Errors errors={errors} />
            <div className={styles['settings-section']}>
                <div className={styles['settings-option']}>
                    <label style={{ width: '100%' }} htmlFor="image_src">{I18n.t('image_src')}</label>
                    <input 
                        type="text" 
                        className="form-control"
                        name="image_src" 
                        value={image_src}
                        placeholder={IMG_PLACEHOLDER}
                        onChange={e => setAttribute('settings.image_src', e.target.value)} 
                    />
                    <p className='description'>{I18n.t('image_widget_primary_source_info')}</p>
                </div>
                <div className={`${styles['settings-option']} ${errors.link ? 'form-error' : ''}`}>
                    <label style={{ width: '100%' }} htmlFor='link'>{I18n.t('link')} ({I18n.t('optional')})</label>
                    <input
                        type="url" 
                        className="form-control"
                        name="link" 
                        value={link} 
                        onChange={e => setAttribute('settings.link', e.target.value)} 
                    />
                    <p className='description'>{I18n.t('image_widget_link_description')}</p>
                </div>
                <div className={styles['settings-option']}>
                    <label>{I18n.t('attachment')}</label>
                    <DashboardImageUploadButton
                        value={attachment}
                        onChange={(val) => setAttribute('settings.attachment', val)}
                    />
                </div>
                <div className={styles['settings-option']}>
                    <label>{I18n.t('fill_mode')}</label>
                    <div onChange={e => setAttribute('settings.image_size', e.target.value)}>
                        <input type="radio" value="cover" defaultChecked={image_size == 'cover'} name="image_size"/> {I18n.t('no_padding')}
                        <br/>
                        <input type="radio" value="contain" defaultChecked={image_size == 'contain'} name="image_size"/> {I18n.t('fully_visible')}
                    </div>
                </div>
            </div>
        </CollapsibleSection>
        </>
    )
}

export default ImageWidgetSettings;
